import React from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';

import Recommendations from '../Recommendations';
import Selections from '../Selections';
import Order from '../Order';

import styles from './styles.module.css';

const easeIn = [0.4, 0.0, 1, 1];
const easeOut = [0.0, 0.0, 0.2, 1];

const Results = ({
    products, responses, questions, onQuantityChange, hostRef,
}) => (
    <div ref={hostRef}>
        <div className={styles.header}>
            <h1>Your Smart Home Plan</h1>
            <p>
                Based on your selections, we've put together a package of Smart Home products that
                fit your needs and are all compatible with one-another. If you need more or fewer
                of any recommended product, you can change the quantity. When you're ready, click
                "Buy on Amazon" to add it to your Amazon cart!
            </p>
        </div>
        <div className={styles.results}>
            <Recommendations
                key="recommendations"
                products={products}
                onQuantityChange={onQuantityChange}
            />
            <div className={styles.right}>
                <Selections key="selections" answers={responses} questions={questions} />
                <Order key="order" products={products} />
            </div>
        </div>
    </div>
);

Results.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    responses: PropTypes.objectOf(
        PropTypes.objectOf(
            PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
        ),
    ).isRequired,
    questions: PropTypes.objectOf(PropTypes.any).isRequired,
    onQuantityChange: PropTypes.func.isRequired,
    hostRef: PropTypes.func.isRequired,
};

export default posed(Results)({
    preEnter: {
        y: 50,
        opacity: 0,
    },
    enter: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 400,
            ease: easeOut,
        },
        beforeChildren: true,
        staggerChildren: 100,
    },
    exit: {
        y: 50,
        opacity: 0,
        staggerChildren: 50,
        transition: {
            duration: 500,
            ease: easeIn,
        },
    },
});
